import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import { PATH_PARAMETERS_LICENSE } from "~/modules/license/constants";
import { useLicenseStore } from "~/modules/license/stores/useLicenseStore";
import LicensePage from "~/modules/license/views/LicensePage.vue";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_PARAMETERS_LICENSE,
    component: LicensePage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) =>
        !useLicenseStore().isLicenseDeactivated() &&
        canWithRedirection(can, ACLRoles.CAN_READ_LICENSE),
      breadcrumb: BREADCRUMBS.LICENSE,
    },
  },
];

export default routes;
